/**
 * The Defera Miles look at checkout: champagne gold on near-black, so Miles
 * read as something of value and stand apart from the blue card tiles.
 * Shared by the Miles wallet card (MilesCheckoutPanel), booking with Miles
 * alone (MilesOnlyCheckout) and the Miles line in Review's price.
 */
export const milesGold = {
  /** The main Miles action: a gold pill. */
  button:
    'bg-gradient-to-b from-[#fae7b9] via-[#efcf88] to-[#d6aa52] text-[#251b08] shadow-[inset_0_1px_0_rgba(255,255,255,0.7),0_10px_28px_-12px_rgba(233,190,99,0.75)] hover:brightness-[1.06] active:brightness-95 active:scale-[0.985] disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 transition-[filter,transform] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f2d9a0]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-black',
  /** A gold coin, for the Miles emblem. */
  coin:
    'bg-gradient-to-br from-[#fcedc8] via-[#e9c47a] to-[#b98a35] shadow-[inset_0_1px_0_rgba(255,255,255,0.65),inset_0_-1px_0_rgba(0,0,0,0.2),0_4px_14px_-4px_rgba(233,190,99,0.6)]',
  coinIcon: 'text-[#3d2c0c]',
  /** Gold numerals (the balance, what Miles take off). */
  text: 'bg-gradient-to-b from-[#fff6de] via-[#f3d898] to-[#d4a54b] bg-clip-text text-transparent',
  /** Plain gold for small text. */
  ink: 'text-[#f3dca6]',
};

/** The card's own surface: warm near-black lit from the top right. */
export const MILES_CARD_BACKGROUND = [
  'radial-gradient(120% 95% at 100% 0%, rgba(242,217,160,0.17) 0%, rgba(242,217,160,0) 52%)',
  'radial-gradient(90% 75% at 0% 100%, rgba(185,138,53,0.13) 0%, rgba(185,138,53,0) 62%)',
  'linear-gradient(140deg, #1e1b15 0%, #121110 50%, #18150f 100%)',
].join(', ');

/** The Defera script wordmark, filled with gold through the logo's alpha. */
export const MILES_WORDMARK_STYLE = {
  WebkitMaskImage: 'url(/defera-transparent.png)',
  maskImage: 'url(/defera-transparent.png)',
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'left center',
  maskPosition: 'left center',
  backgroundImage: 'linear-gradient(100deg, #f7e4b5 0%, #e3bd72 42%, #fff2d2 58%, #d5a64e 100%)',
};
